import { PatientConstants } from '../constants';
import { PatientService } from '../../services';

export const PatientActions = {
	fetchPatients
};

function fetchPatients(id) {
	return (dispatch) => {
		dispatch(request());

		PatientService.fetchPatients(id).then(
			(patients) => {
				dispatch(success(patients));
			},
			(error) => dispatch(failure(error.toString()))
		);
	};
}

function request() {
	return { type: PatientConstants.CREATEPATIENTS_REQUEST };
}

function success(patients) {
	if (patients) {
		return { type: PatientConstants.GETPATIENTS_SUCCESS, patients };
	} else {
		const patients = [];
		return { type: PatientConstants.GETPATIENTS_FAILURE, patients };
	}
}

function failure(error) {
	return { type: PatientConstants.GETPATIENTS_FAILURE, error };
}


// WEBPACK FOOTER //
// ./src/store/actions/patient.actions.js